import { PartialPalette, PartialSemanticColors, PartialTheme, twoUIPaletteColors } from "../types";
import { familyPalette } from "./FamilyTheme";

export const familyInsightsPaletteColors = [
    ...twoUIPaletteColors
] as const;

export const familyInsightsPalette: PartialPalette & { [K in typeof familyInsightsPaletteColors[number]]: string } = {
    themePrimary: "#027063",
    themeLighterAlt: "#f0f9f8",
    themeLighter: "#c4e8e4",
    themeLight: "#96d4cd",
    themeTertiary: "#46a99e",
    themeSecondary: "#128174",
    themeDarkAlt: "#026559",
    themeDark: "#02554c",
    themeDarker: "#013f38",
    neutralLighterAlt: "#c0e2de",
    neutralLighter: "#bddeda",
    neutralLight: "#b5d5d1",
    neutralQuaternaryAlt: "#a9c6c3",
    neutralTertiary: "#a19f9d",
    neutralTertiaryAlt: "#9bb6b3",
    neutralSecondary: "#605e5c",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
    neutralMed: "#fafafa",
    neutralHigh: "#ffffff",
    transparent: "transparent",
    black: "#000000",
    white: "#c5e9e5",
    redDark: "#a4262c",
    redLight: "#feece5",
    highlighter: "#f8d22a"
};

export const familyInsightsSemanticColors: PartialSemanticColors = {
    bodyBackground: familyInsightsPalette.white,
    navBackground: familyInsightsPalette.white,
    navItemBackgroundHovered: familyInsightsPalette.neutralLighter,
    navItemBackgroundPressed: familyInsightsPalette.neutralLight,
    severeWarning: "#fed9cc",
    errorBlockIcon: "#a8000",
    messageLink: familyPalette.themeDarkAlt,
    messageWebSuccess: "#107c10",
    cautionYellow: "#9D5D00"
};

export const familyInsightsTheme: PartialTheme = { palette: familyInsightsPalette, semanticColors: familyInsightsSemanticColors };
